import { LocalStorageConfig as NgLocalStorageConfig } from 'ngrx-store-localstorage/lib';
import { TypedAction } from '@ngrx/store/src/models';

export const StorageChangeActionType = '[Store] Changed';
export type StorageChangeAction = { readonly key: string } & TypedAction<typeof StorageChangeActionType>;

export type LocalStorageConfig<T extends object> = Omit<NgLocalStorageConfig, 'storageKeySerializer' | 'mergeReducer' | 'keys'> & {
  readonly serializationKey: string;
  readonly initialState?: T,
  readonly keys?: readonly (keyof T)[],
};
